import { render, staticRenderFns } from "./FormInputIntegerWidget.vue?vue&type=template&id=4853b382&"
import script from "./FormInputIntegerWidget.vue?vue&type=script&lang=js&"
export * from "./FormInputIntegerWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports